import activeAgreements from './activeAgreements';
import baseVES from './base';
import countryDashboardsVES from './countryDashboards';
import dashboardsVES from './dashboards';
import economicRelations from './economicRelations';
import eventsVES from './events';
import eventsCardVES from './eventsCardVES';
import implementation from './implementation';
import projectWithNations from './projectWithNations';
import projectWithRegions from './projectWithRegions';
import regionDashboardsVES from './regionDashboards';

export default {
  baseVES,
  economicRelations,
  eventsVES,
  implementation,
  activeAgreements,
  dashboardsVES,
  regionDashboardsVES,
  projectWithRegions,
  projectWithNations,
  countryDashboardsVES,
  eventsCardVES,
};
